import { useSuspenseQuery } from '@tanstack/react-query';
import { getFrequencyOptions } from '@generated';
import { Button } from '~/shared/components/buttons/Button';
import { Modal } from '~/shared/components/modal/Modal';
import { FooterButtonContainer } from '~/shared/forms/buttons/FooterButtonContainer';
import { useNavigate } from 'react-router-dom';

export function PendingMissedVisitModal({ stayId, frequencyId, onClose }: { stayId: string; frequencyId: string; onClose: () => void }) {
	const { data: frequency } = useSuspenseQuery(getFrequencyOptions(frequencyId));
	const navigate = useNavigate();

	return (
		<Modal
			title="Referral Details"
			closeModal={onClose}
			footer={
				<FooterButtonContainer>
					<Button onClick={onClose} appearance="outline" intent="neutral" label="Close" />
				</FooterButtonContainer>
			}
		>
			<p>est</p>
		</Modal>
	);
}
